import React from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { updateInternalWorkspaceAttachmentsForSupplier } from '../../thunks/work_orders_thunks';
import { getInternalNotesChannelId } from '../../utils/WorkOrderUtils';
import FileUploader from '../file_uploader/FileUploader';

interface InternalWorkspaceAttachmentsTabProps {
	workOrderId: string;
	internalMessages: any;
	updateInternalWorkspaceAttachments: (payload: { id: string; attachments: any[] }) => Promise<any>;
}

const InternalWorkspaceAttachmentsTab = ({
	workOrderId,
	internalMessages,
	updateInternalWorkspaceAttachments,
}: InternalWorkspaceAttachmentsTabProps) => {
	// Always read from the messages slice populated by fetchInternalWorkspace.
	// The API returns attachments under `internalAttachments` for all WO types.
	const attachments = nullSafeGetOrElse('internalAttachments', internalMessages, []);

	const saveAttachments = (newAttachments) =>
		updateInternalWorkspaceAttachments({ id: workOrderId, attachments: newAttachments });

	const handleAttachmentUpdateFailure = () => {
		message.error('Failed to upload document');
	};

	const handleAttachmentUpload = (newAttachments) => {
		const callUpdate = newAttachments.every(
			(element) => element && element.fileId && element.fileName
		);
		if (!callUpdate) return;

		const savePromise = saveAttachments(newAttachments);
		if (savePromise && typeof savePromise.catch === 'function') {
			savePromise.catch(handleAttachmentUpdateFailure);
		}
	};

	return (
		<div className="flex flex-col">
			{/* File Uploader */}
			<div className="mb-4">
				<FileUploader
					defaultFileList={attachments}
					convertedImages={nullSafeGet('convertedImages', internalMessages)}
					roleType="supplier"
					handleUploadSuccess={handleAttachmentUpload}
					uploaderType={'dragger'}
					multiple
				/>
			</div>
		</div>
	);
};

// Look the work order up by the id in the URL, matching InternalWorkspaceNotesTab (which uses
// getWorkOrderSelector, the same getEntityById lookup). Reading `state.work_orders.detail` — a
// global "last touched work order" pointer overwritten by any create/update/readOne of ANY work
// order — showed, and saved uploads against, the wrong work order.
const mapStateToProps = (state, ownProps) => {
	const workOrder = getEntityById(nullSafeGet('match.params.id', ownProps), state.work_orders);
	const workOrderId = nullSafeGet('id', workOrder);
	const channelId = workOrderId ? getInternalNotesChannelId(workOrderId) : null;
	return {
		workOrderId,
		internalMessages: channelId ? state.messages[channelId] : null,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateInternalWorkspaceAttachments: (payload) =>
		dispatch(updateInternalWorkspaceAttachmentsForSupplier(payload)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(InternalWorkspaceAttachmentsTab)
);
